define([
  'js/aofl-js/0.8.0/app/app',
  'text!readingiq-src/js/riq-js/riq-child-form/1.0.0/index.html',
  'text!readingiq-src/js/riq-js/riq-child-form/1.0.0/index-redeem.html',
  'text!readingiq-src/js/riq-js/riq-child-form/1.0.0/index.css',
  'readingiq-src/js/riq-js/riq-child-form/1.0.0/toastr-config',
  'js/aofl-js/0.8.0/aofl-modules/__build/aofljs.min',
  'readingiq-src/js/riq-js/riq-child-form/1.0.0/js/state-service/1.0.0/index',
  'readingiq-src/js/riq-js/riq-child-form/1.0.0/js/vm-service/1.0.0/index',
  'readingiq-src/js/riq-js/riq-toastr-service/1.0.0/index',
  'readingiq-src/js/riq-js/group-state-service/1.0.0/index',
  'readingiq-src/js/riq-js/riq-dropdown/1.0.0/index',
  'readingiq-src/js/riq-js/aofl-select-list/1.0.0/index',
  'readingiq-src/js/riq-js/aofl-list-option/1.0.0/index',
  'readingiq-src/js/riq-js/select-avatar/1.0.0/index',
  'readingiq-src/js/riq-js/info-message-modal/1.0.0/index',
  'readingiq-src/js/riq-js/navigation-bar/1.0.0/index',
  'readingiq-src/js/comprehension-check-js/placement-validate-modal/1.0.0/index',
  'readingiq-src/js/riq-js/access-control-service/1.0.0/index'
], function riqChildFormModule(
  app,
  html,
  redeemHtml,
  css,
  toastrConfig,
  aoflModules
) {
  'use strict';

  var storeService = aoflModules.store;

  const selectTemplate = [
    '$element',
    '$attrs',
    ($el, $attrs) => {
      // Hardcoded for now. Can be changed to be dynamic.
      return $attrs.customTemplate === 'redeem' ? redeemHtml : html;
    }
  ];

  app.registerComponent('riqChildForm', {
    bindings: {
      customTemplate: '&',
      formState: '<',
      previousState: '<',
      previousStateParams: '<',
      onComplete: '&?',
      onPlacement: '&?',
      profileUuid: '@',
      isOnboarding: '<',
      goBack: '&'
    },
    controller: 'riqChildFormController',
    template: selectTemplate
  });

  app.registerController('riqChildFormController', [
    '$scope',
    '$state',
    '$element',
    'compileService',
    'riqChildFormStateService',
    'riqChildFormVmService',
    'riqToastrService',
    'applicationPathName',
    'gettext',
    'ngDialog',
    'accessControlService',
    function riqChildFormController(
      $scope,
      $state,
      $element,
      compileService,
      stateService,
      vmService,
      riqToastrService,
      applicationPathName,
      gettext,
      modalService,
      accessControlService
    ) {
      var vm = this;
      vm.can = accessControlService.can;

      var init = vmService.init;
      var setFormState = vmService.setFormState;
      var clearData = vmService.clearData;
      var getChildren = vmService.getChildren;
      var isPlacementSelected = false;

      const getPlacementAccess = () => {
        return accessControlService.canViewState({
          name: 'placement_assessment_en'
        });
      };

      vm.getPlacementHistory = vmService.getPlacementHistory;
      vm.setFirstName = vmService.setFirstName;
      vm.setLevel = vmService.setLevel;
      vm.setAvatar = vmService.setAvatar;
      vm.setView = vmService.setView;
      vm.deleteChild = vmService.deleteChild;
      vm.setUserOnboarding = vmService.setUserOnboarding;
      vm.closeModal = vmService.closeModal;
      vm.applicationPathName = applicationPathName;
      vm.profileUuid = $state.params.profile;
      vm.showRemoveChildButton = false;
      vm.placeholders = {
        // eslint-disable-next-line quotes
        name: gettext("Child's First Name")
      };

      vm.formValidations = {
        name: {
          maxlength: 30,
          pattern: /^[a-zA-Z0-9\-'\s]{1,}$/
        }
      };
      vm.formStates = {
        create: 'create',
        edit: 'edit'
      };

      riqToastrService.registerToastr(toastrConfig);
      storeService.addState(stateService);

      var mapProperties = function mapProperties() {
        var state = storeService.getState();
        vm.childForm = state.riqChildForm;
        vm.name = state.riqChildForm.name;
        vm.level = state.riqChildForm.level;
        vm.levels = state.riqChildForm.levels;
        vm.avatars = state.riqChildForm.avatars;
        vm.selectedAvatar = state.riqChildForm.avatar;
        vm.view = state.riqChildForm.view;
        vm.showPlacement =
          state.riqChildForm.placementAssessmentLevels.includes(
            vm.childForm.levelId
          ) && getPlacementAccess();
        if (state.riqDropdowns) {
          vm.dropdown = state.riqDropdowns.childFormLevelDropdown;
        }
        if (state.group) {
          vm.groupUuid = state.group.groupUuid;
          vm.profiles = state.group.profiles;
          vm.showRemoveChildButton =
            !vm.isOnboarding &&
            state.group.profiles &&
            state.group.profiles.length > 1;
        }
        vm.showNavigationBar =
          vm.isOnboarding &&
          vm.formState &&
          vm.formState === vm.formStates.create &&
          vm.profiles &&
          vm.profiles.length > 0;
      };

      vm.$onInit = function onInit() {
        mapProperties();
        if (vm.formState === vm.formStates.create) {
          setFormState(vm.formState);
          init();
        }
        if (!vm.profiles || (vm.profiles.length === 0 && !vm.isOnboarding)) {
          getChildren();
        }
      };
      let once = false;
      vm.$onChanges = function onChange(changes) {
        if (changes.profileUuid.currentValue && !once) {
          once = true;
          init(changes.profileUuid.currentValue);
          setFormState(vm.formState);
        }
      };

      vm.openConfirmDeleteChildModal = function openConfirmDeleteChildModal() {
        modalService.open({
          template: 'confirmDeleteChild',
          disableAnimation: true,
          preserveFocus: false,
          trapFocus: false,
          className: 'ngdialog-theme-default',
          closeByNavigation: false,
          closeByEscape: false,
          closeByDocument: false,
          scope: $scope,
          controller: 'InfoMessageModalController',
          controllerAs: 'infoMessageModalCtrl'
        });
      };

      vm.openPlacementLearnMoreModal = function openPlacementLearnMoreModal() {
        modalService.open({
          template: 'placementLearnMore',
          disableAnimation: true,
          preserveFocus: false,
          trapFocus: false,
          className: 'ngdialog-theme-default placementLearnMore',
          closeByNavigation: false,
          closeByEscape: false,
          closeByDocument: false,
          scope: $scope,
          controller: 'InfoMessageModalController',
          controllerAs: 'infoMessageModalCtrl'
        });
      };

      vm.cancel = function cancel() {
        $state.go(vm.previousState, vm.previousStateParams);
      };

      vm.setPlacement = function setPlacement() {
        isPlacementSelected = true;
        vm.validatePlacement = false;
      };

      vm.startPlacement = function startPlacement(payload) {
        const state = storeService.getState();
        var isNewUser =
          vm.isOnboarding || vm.formState === vm.formStates.create;
        vmService
          .submitForm(payload, {
            profileSwap: isNewUser,
            useOnBoardingEndpoint: false
          })
          .then(() => {
            vm.onPlacement();
            localStorage.setItem(
              'riqUserStartedPlacement',
              state.user.userUuid
            );
          });
      };

      /**
       * onValidatePlacement
       * @param {Object} payload child form data
       *
       * Business rules based on user's state to determine if they should see a warning modal or take an assessment:
       * 'placement' - If the set grade level is not the current grade level and the user has not been placed at the set grade level.
       * 'switch' - If the active user is not the current user.
       * start assessment - If the active user is the current user and they have already been placed at the selected grade level.
       */
      vm.onValidatePlacement = function(payload) {
        var state = storeService.getState();
        var isPlacementComplete =
          state.riqChildForm.placementAssessment.gradeLevelsTaken.length > 0;
        var isProgressMonitor = state.riqChildForm.placementAssessment.gradeLevelsTaken.includes(
          vm.childForm.levelId
        );
        var isActiveUser = vm.profileUuid === state.profile.profileUuid;
        isPlacementSelected = false;
        vm.validatePlacement = true;

        if (!isProgressMonitor && isPlacementComplete) {
          vm.placementState = 'placement';
        } else if (isActiveUser === false) {
          vm.placementState = 'switch';
        } else {
          vm.validatePlacement = false;
          vm.startPlacement(payload);
        }
      };

      var storeUnsubscribe = storeService.subscribe(function subscribe() {
        $scope.$applyAsync(mapProperties);
      });

      vm.$onDestroy = function onDestroy() {
        clearData();
        storeUnsubscribe();
      };
      vm.submitForm = function submitForm(payload) {
        if (isPlacementSelected) {
          if (vm.formState === vm.formStates.edit) {
            vm.getPlacementHistory(vm.profileUuid).then(function() {
              vm.onValidatePlacement(payload);
            });
          } else if (vm.isOnboarding) {
            vm.startPlacement(payload);
          } else {
            vm.validatePlacement = true;
            vm.placementState = 'switch';
          }
        } else {
          vmService
            .submitForm(payload, {
              useOnboardingEndpoint: vm.isOnboarding,
              profileSwap: vm.isOnboarding
            })
            .then(vm.onComplete);
        }
      };
      compileService.compile(
        {
          css: css
        },
        $scope,
        $element
      );
    }
  ]);
});
